/**
 * Tracks late / early grace usage per employee per policy window (localStorage v1).
 */

const STORAGE_KEY = "hrms_attendance_grace_ledger_v1";

function windowKey(employeeId, date, windowType = "monthly") {
  const d = date instanceof Date ? date : new Date(date);
  const y = d.getFullYear();
  const m = d.getMonth() + 1;
  if (windowType === "weekly") {
    const oneJan = new Date(y, 0, 1);
    const week = Math.ceil(((d - oneJan) / 86400000 + oneJan.getDay() + 1) / 7);
    return `${employeeId}:weekly:${y}-W${week}`;
  }
  if (windowType === "quarterly") {
    const q = Math.floor((m - 1) / 3) + 1;
    return `${employeeId}:quarterly:${y}-Q${q}`;
  }
  return `${employeeId}:monthly:${y}-${String(m).padStart(2, "0")}`;
}

function loadAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const parsed = raw ? JSON.parse(raw) : {};
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
}

function saveAll(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    /* ignore */
  }
}

export function getGraceUsage(employeeId, date, windowType = "monthly") {
  const key = windowKey(employeeId, date, windowType);
  const all = loadAll();
  return all[key] || { lateCount: 0, earlyCount: 0 };
}

export function recordGraceUsage(employeeId, date, { late = false, early = false, windowType = "monthly" } = {}) {
  const key = windowKey(employeeId, date, windowType);
  const all = loadAll();
  const cur = all[key] || { lateCount: 0, earlyCount: 0 };
  if (late) cur.lateCount = (cur.lateCount || 0) + 1;
  if (early) cur.earlyCount = (cur.earlyCount || 0) + 1;
  all[key] = cur;
  saveAll(all);
  return cur;
}

export function canConsumeLateGrace(employeeId, date, allowed, windowType = "monthly") {
  if (!allowed || allowed <= 0) return false;
  const usage = getGraceUsage(employeeId, date, windowType);
  return (usage.lateCount || 0) < allowed;
}

export function canConsumeEarlyGrace(employeeId, date, allowed, windowType = "monthly") {
  if (!allowed || allowed <= 0) return false;
  const usage = getGraceUsage(employeeId, date, windowType);
  return (usage.earlyCount || 0) < allowed;
}
